module.exports = __webpack_public_path__ + "static/media/new-tag-mobile.db1ac1f5.svg";